import Vue from 'vue'
import Vuex from 'vuex'
import util from '@/libs/util'

Vue.use(Vuex)

const shouldUseTransition = !/transition=none/.test(location.href)

const history = window.sessionStorage

let state = {
    route: { path: '' },
    basicSize: 1080,
    viewport: {
        width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    },
    isLoading: false,
    direction: shouldUseTransition ? 'forward' : '',
    token: 'yunyan1536161856',
    sign: '',
    myApplyObj: {},
    video_jobfair_id: '',
    subTitle: util.getQueryString('title'),
    login_state: 0, // 登录标记参数
    checkedjobfair: { name: '选择视频双选会' }, // 选择的双选会
    change_jobfair: {
        video_jobfair_id: '',
    },
    queueState: {
        "0-0": "处理邀约",
        "1-0": "取消排队",
        "2-0": "已拒绝",
        "0-1": "待确认",
        "1-1": "取消排队",
        "2-1": "已拒绝",
    },
    queueType: {
        0: "企业邀约",
        1: "申请面试",
        2: "面试"
    },
    faceState: {
        0: "取消排队",
        1: "面试中",
        2: "面试已结束"
    },
    showQuickFace: false,
    user_id: 0,
    websocket: null,
    websocket_send_data: {},  // 即时发送消息
    websocket_send_queue: [], // 发送队列
    companyOnline: {},      // 在线公司对象
    companyBusiness: {},    // 公司忙碌状态对象
    invitation_apply_id: 0, // 面试id
    wait_invitation_apply_id: 0, // 主动发起的面试
    seeker_openid: history.getItem('seeker_openid'), // 用户openid
    refreshHome: {
        wait: false
    },
    refusedFace: {},
    queueObj: {},   // 企业排队状态
}

const store = new Vuex.Store({
    state,
    mutations: {
        update_route(state, payload) {
            state.route = payload.data
            state.showQuickFace = true
        },
        updateDirection(state, payload) {
            if (!shouldUseTransition) {
                return
            }
            state.direction = payload.direction
        },
        updateLoadingStatus(state, payload) {
            state.isLoading = payload.isLoading
        },
        updateSign(state, payload) {
            const { sign } = payload
            sessionStorage.setItem("sign", sign)
            state.sign = sign
        },
        updateMyApply(state, payload) {
            const {
                data
            } = payload
            state.myApplyObj = data
        },
        addMyApply(state, payload) {
            const { video_jobfair_id, student_register_id } = payload;
            if (video_jobfair_id) {
                state.myApplyObj[video_jobfair_id] = { video_jobfair_id, student_register_id };
            }
        },
        updateJobfairDetail(state, payload) {
            state.video_jobfair_id = payload
        },
        setSubTitle(state, payload) {
            const { title } = payload
            state.subTitle = title;
        },
        updateLoginState(state) {
            state.login_state++
        },
        updateCheckedjobfair(state, payload) {
            state.checkedjobfair = payload
        },
        update_change_jobfair(state, payload) {
            const {
                video_jobfair_id
            } = payload
            if (video_jobfair_id) {
                state.change_jobfair.video_jobfair_id = video_jobfair_id
            }
        },
        updateQuickFace(state, payload) {
            state.showQuickFace = payload
        },
        updateUserId(state, payload) {
            state.user_id = payload
        },
        updateUserName(state, payload) {
            state.user_name = payload
        },
        updateWebsocket(state, payload) {
            state.websocket = payload
        },
        update_websocket_send_queue(state, payload) {
            const {
                type, data, key, value
            } = payload

            if (type === 'push' && data) {
                state.websocket_send_queue.push(data)
            } else if (type === 'shift') {
                if (value && state.websocket_send_queue[0] && value === state.websocket_send_queue[0][key]) {
                    state.websocket_send_queue.shift()
                }
            }
        },
        updateCompanyOnline(state, payload) {
            const {
                list
            } = payload

            let companyOnline = {}, current_item, companyBusiness = {};
            list.forEach((item) => {
                try {
                    current_item = typeof item === 'string' ? JSON.parse(item) : item
                    var items = current_item.key.split('_');
                    var company_id;
                    if (items && items[0] === 'G' && items[2] === 'company') {
                        company_id = items[1]
                        companyOnline[company_id] = true;
                    }

                    var state = current_item.state

                    if (company_id && state && parseInt(state) === 1){
                        companyBusiness[company_id] = state
                    }
                } catch (error) {
                    // 
                }
            })
            state.companyOnline = companyOnline
            state.companyBusiness = companyBusiness
        },
        update_invitation_apply_id(state, payload) {
            // -5: 挂断， -6: 结束
            state.invitation_apply_id = payload
        },
        update_wait_invitation_apply_id(state, payload) {
            state.wait_invitation_apply_id = parseInt(payload)
        },
        update_openid(state, payload) {
            const seeker_openid = payload

            state.seeker_openid = seeker_openid
            history.setItem('seeker_openid', seeker_openid)
        },
        updateRefreshHome(state, payload) {
            const { key, val } = payload

            if (key) {
                state.refreshHome[key] = val
            }
        },
        update_refused_face(state, payload) {
            const { key, val } = payload

            if (key) {
                const timestamp = (new Date()).getTime()
                state.refusedFace[key] = { val, timestamp }
            }
        },
        update_single_state(state, payload) {
            const {
                key, data
            } = payload

            if (!key || state[key] === undefined) {
                return
            }

            state[key] = data
        },
    },
    actions: {
        getMyApply(context, params) {
            return new Promise((resolve) => {
                util.get("kzp_video_jobfair", "my_video_jobfair", params)
                    .then(res => {
                        const { code, data } = res;
                        if (code === 1) {
                            const {
                                list, user
                            } = data

                            const {
                                user_id, user_name, openid
                            } = user || {}

                            context.commit('updateUserId', user_id)
                            context.commit('updateUserName', user_name)
                            context.commit('update_openid', openid)

                            let obj = {}
                            list.forEach(item => {
                                obj[item.video_jobfair_id] = item
                            });
                            context.commit('updateMyApply', { data: obj })
                        }

                        resolve(res)
                    })
            })
        },
        registerJobfair(context, params) {
            const { video_jobfair_id } = params
            return new Promise((resolve) => {
                util.post("kzp_video_jobfair", "register_video_jobfair", params)
                    .then(res => {
                        const { msg, code, data } = res;
                        if (code === 1) {
                            context.commit('addMyApply', { video_jobfair_id, student_register_id: data })
                            resolve(res)
                        } else if (msg === '请勿重复报名') {
                            context.dispatch('getMyApply', params).then(resolve)
                        } else {
                            resolve(res)
                        }
                    })
            })
        },
        getSubscribe(context, params) {
            // 判断用户是否已经关注了云就业
            return new Promise((resolve) => {
                util.get("kzp_user", "subscribe", params)
                    .then(res => {
                        resolve(res)
                    })
            })
        }
    }
})

export default store